<template>
  <Form :onSubmit="handleInternalSubmit">
    <form-element :style="{ maxWidth: '650px' }">
      <fieldset class="k-form-fieldset">
        <div class="mb-3">
          <field name="fName" :component="'myTemplate'" label="First name">
            <template #myTemplate="{ props }">
              <forminput v-bind="props" />
            </template>
          </field>
        </div>

        <div class="mb-3">
          <field name="lName" :component="'myTemplate'" label="Last name">
            <template #myTemplate="{ props }">
              <forminput v-bind="props" />
            </template>
          </field>
        </div>

        <div class="mb-3">
          <field
            name="email"
            type="email"
            :component="'myTemplate'"
            label="Email"
            :validator="emailValidator"
          >
            <template #myTemplate="{ props }">
              <forminput v-bind="props" />
            </template>
          </field>
        </div>

        <div class="mb-3 two-cols">
          <div class="field-col">
            <field
              name="phone"
              :component="'myTemplate'"
              label="Phone Number"
              :validator="phoneValidator"
            >
              <template #myTemplate="{ props }">
                <forminput v-bind="props" @change="(e) => formatPhoneNumber(e, props)" />
              </template>
            </field>
          </div>

          <div class="field-col">
            <field
              name="zipCode"
              :component="'myTemplate'"
              label="Zipcode"
              :validator="zipValidator"
            >
              <template #myTemplate="{ props }">
                <forminput v-bind="props" />
              </template>
            </field>
          </div>
        </div>
      </fieldset>

      <div class="k-form-buttons">
        <kbutton type="submit">Submit</kbutton>
        <kbutton type="button" @click="clear">Clear</kbutton>
      </div>
    </form-element>
  </Form>
</template>

<script>
import { Field, FormElement, Form } from "@progress/kendo-vue-form";
import { Button as kbutton } from "@progress/kendo-vue-buttons";
import forminput from "./FormInput.vue";

  export default {
  components: {
    Field,
    FormElement,
    Form,
    forminput,
    kbutton,
  },
  emits: ["submit"],
  methods: {
    emailValidator(value) {
      return /\S+@\S+\.\S+/.test(value) ? "" : "Please enter a valid email.";
    },
    phoneValidator(value) {
      if (typeof value !== "string") return "Enter a 10-digit phone number";
      const digits = value.replace(/\D/g, "");
      return /^\d{10}$/.test(digits) ? "" : "Enter a 10-digit phone number";
    },
    zipValidator(value) {
      return /^\d{5}$/.test(value) ? "" : "Enter a valid 5-digit ZIP code";
    },
    handleInternalSubmit(dataItem, event) {
      if (event) event.preventDefault();
      this.$emit("submit", dataItem);
    },
    clear() {
      window.location.reload();
    },
    formatPhoneNumber(e, props) {
      const digits = e.target.value.replace(/\D/g, "").substring(0, 10);
      let formatted = "";
      if (digits.length > 0) formatted += "(" + digits.substring(0, 3);
      if (digits.length >= 4) formatted += ") " + digits.substring(3, 6);
      if (digits.length >= 7) formatted += "-" + digits.substring(6, 10);
      props.onChange({ field: props.name, value: formatted });
    },
  },
};

</script>

<style scoped>
.two-cols {
  display: flex;
  gap: 1rem;
}
.field-col {
  flex: 1;
}
</style>
